import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { FiArrowLeft } from 'react-icons/fi';
import { createArticle } from '../../../services/firebase/blogService';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../../services/firebase/config';
import ArticleForm from '../../components/ArticleForm';

const CreateArticle = () => {
  const [loading, setLoading] = useState(false);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    if (!user) {
      toast.error('Önce giriş yapmalısınız');
      return;
    }

    try {
      setLoading(true);
      await createArticle(formData, user.email);
      toast.success('Makale başarıyla oluşturuldu');
      navigate('/admin/blog');
    } catch (error) {
      console.error('Makale oluşturulurken hata:', error);
      toast.error('Makale oluşturulurken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Yeni Makale Oluştur</h1>
        <button
          onClick={() => navigate('/admin/blog')}
          className="flex items-center text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
        >
          <FiArrowLeft className="mr-2" />
          Listeye Dön
        </button>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <ArticleForm 
          onSubmit={handleSubmit} 
          isLoading={loading} 
        />
      </div>
    </div>
  );
};

export default CreateArticle;